module.exports = __webpack_public_path__ + "static/error1-2629293d65a090325b853a564571c3ec.png";